import { useEffect, useState } from 'react'

import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'
import { useGetQuote } from 'components/hooks/useGetQuote'
import LoadingSpinnerCentered from 'components/reusable/LoadingSpinnerCentered'
import { adminQuote } from 'rails_routes'
import { ButtonLink } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

const QuoteProcessing = ({
  prospectId,
  quoteId,
  onCompleteRoute = adminQuote.explore({ prospect_id: prospectId, id: quoteId }),
}: {
  prospectId: string,
  quoteId: string,
  onCompleteRoute?: string
}) => {
  const { replace } = useWindowLocation()

  const [error, setError] = useState<GrapeAPIErrorType | null>(null)
  const { data, error: queryError } = useGetQuote({
    prospectId,
    quoteId,
    refetchUntilProcessed: true,
  })

  useEffect(() => {
    if (queryError) {
      setError(queryError)
    } else if (['processed', 'failed'].includes(data?.status ?? '')) {
      replace(onCompleteRoute)
    }
  }, [data, queryError])

  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <div className='text-lg'>
        {error
          ? (
            <div className='text-red-500'>
              {error.message}
              {error.status !== 404 && <ButtonLink href={window.location.href}>Retry</ButtonLink>}
            </div>
            )
          : <>Processing your quote <LoadingSpinnerCentered /></>}
      </div>
    </div>
  )
}

export default ({ prospectId, quoteId, onCompleteRoute }: { prospectId: string, quoteId: string, onCompleteRoute: string }) => {
  return (
    <QuoteProcessing prospectId={prospectId} quoteId={quoteId} onCompleteRoute={onCompleteRoute} />
  )
}
